import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { CurriculumSection } from './components/CurriculumSection';
import { BenefitsSection } from './components/BenefitsSection';
import { WhatsAppResultsSection } from './components/WhatsAppResultsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { PricingSection } from './components/PricingSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { FaqSection } from './components/FaqSection';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const w = window as any;
    if (w.fbq) return;
    const fbq: any = function () {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    w.fbq = fbq;
    w._fbq = fbq;
    // Load the Facebook pixel script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Initialize pixel and track PageView
    w.fbq('init', '1330703321986109');
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen w-full bg-white font-body" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1330703321986109&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <HeroSection data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <SolutionSection data-id="element-5" />
      <CurriculumSection data-id="element-6" />
      <BenefitsSection data-id="element-7" />
      <WhatsAppResultsSection data-id="element-8" />
      <TestimonialsSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <PricingSection data-id="element-11" />
      <FinalCtaSection data-id="element-12" />
      <FaqSection data-id="element-13" />
    </div>;
}